import { atom } from 'jotai';
import { atomWithReducer } from 'jotai/utils';
import { ToastMessageStatus, } from '../types/index.js';
import { ToastMapActionTypes } from '../constants/index.js';
const toastMapReducer = (prev, action) => {
    switch (action.type) {
        case ToastMapActionTypes.ADD: {
            const newMap = new Map(prev);
            const key = action.toast.key ?? String(Date.now());
            newMap.set(key, {
                ...action.toast,
                key,
            });
            return newMap;
        }
        case ToastMapActionTypes.REMOVE: {
            if (action.toast.key) {
                const newMap = new Map(prev);
                newMap.delete(action.toast.key);
                return newMap;
            }
            else {
                console.warn(`ToastMapReducer REMOVE called without a key`);
                return prev;
            }
        }
        default:
            return prev;
    }
};
export const toastMapState = atomWithReducer(new Map(), toastMapReducer);
export const selectToastList = atom((get) => {
    const toastMap = get(toastMapState);
    return Array.from(toastMap.values());
});
// Helper methods
const createNotice = (notice, status) => {
    const toast = {
        title: notice.title,
        message: notice.message,
        status,
    };
    return {
        type: ToastMapActionTypes.ADD,
        toast,
    };
};
export const notifyDefault = (notice) => {
    return createNotice(notice, ToastMessageStatus.DEFAULT);
};
export const notifyError = (notice) => {
    return createNotice(notice, ToastMessageStatus.ERROR);
};
export const notifyInfo = (notice) => {
    return createNotice(notice, ToastMessageStatus.INFO);
};
export const notifySuccess = (notice) => {
    return createNotice(notice, ToastMessageStatus.SUCCESS);
};
export const notifyWarning = (notice) => {
    return createNotice(notice, ToastMessageStatus.WARNING);
};
//# sourceMappingURL=toast-map.js.map